// Module
var code = "<svg width=\"28\" height=\"28\" viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"jw-svg-icon jw-svg-icon-play\"> <path d=\"M19.8 12.5381L9.6 6.13808C8.9 5.73808 8 6.23809 8 7.23809V20.0381C8 20.9381 8.9 21.5381 9.6 21.1381L19.8 14.7381C20.6 14.1381 20.6 12.9381 19.8 12.5381Z\"/> </svg> ";
// Exports
module.exports = code;